import * as React from 'react';
import * as Yup from 'yup';

import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

import { Formik, FormikProps } from 'formik';
import { FormInput } from 'common/components/form/FormInput';
import { VoucherApi } from 'common/api/resources/Voucher';
import moment = require('moment');
import { Member } from 'common/api/models/Member';

export interface Day {
  day: number;
}
interface NumericDialogProps {
  isOpen: boolean;
  voucher: string;
  onSave: () => void;
  onCancel: () => void;
  error?: string;
  title?: string;
  saveLabel?: string;
  activatedDate?: string;
  expireDate?: string;
  originalExpireDate?: string;
  orderId?: string;
  productId?: string;
  member?: Member;
}
class NumericValues {
  day = 0;
}

export class DayDialog extends React.Component<NumericDialogProps> {
  validationSchema = Yup.object().shape({
    day: Yup.number().required('Required'),
  });

  initialValues() {
    // console.log(this.props.activatedDate);
    return {
      day: 1,
    };
  }

  handleSubmit = async (values: NumericValues) => {
    let expireDate = moment(this.props.expireDate)
      .add(values.day, 'days')
      .toISOString();
    // console.log(activatedDate);
    await this.setState({ isLoading: true });
    if (this.props.voucher) {
      VoucherApi.updateVoucher(this.props.voucher, {
        expireDate: expireDate,
      })
        .then(() => {
          this.setState({ isLoading: false });
          this.props.onSave();
        })
        .catch(e => {
          this.setState({ isLoading: false });
        });
    } else {
      // console.log(this.props.member ? this.props.member.id : 'no member id.');
      // console.log(this.props.productId + ' - ' + this.props.orderId);
      let memberId: string = this.props.member ? this.props.member.id! : '';

      if (memberId !== '') {
        VoucherApi.extendEligibility(memberId, {
          orderId: this.props.orderId,
          productId: this.props.productId,
          activatedDate: expireDate,
        })
          .then(() => {
            this.setState({ isLoading: false });
            this.props.onSave();
          })
          .catch(e => {
            this.setState({ isLoading: false });
          });
      }
    }
  };

  render() {
    return (
      <Modal size="md" isOpen={this.props.isOpen} toggle={this.props.onCancel} keyboard={true}>
        <Formik
          initialValues={this.initialValues()}
          onSubmit={this.handleSubmit}
          render={(form: FormikProps<NumericValues>) => (
            <form onSubmit={form.handleSubmit}>
              <ModalHeader toggle={this.props.onCancel}>{this.props.title ? this.props.title : ''}</ModalHeader>
              <ModalBody>
                {this.props.originalExpireDate &&
                  this.props.originalExpireDate !== '' && (
                    <label>Original expiration date: {moment(this.props.originalExpireDate).format('L')}</label>
                  )}
                <label>Current expiration date: {moment(this.props.expireDate).format('L')}</label>
                <FormInput label="Extend day(s):" name="day" id="day" type="number" min="1" />
              </ModalBody>
              <ModalFooter>
                <div>
                  <Button color="secondary" onClick={this.props.onCancel}>
                    Cancel
                  </Button>{' '}
                  <Button color="primary" type="submit">
                    {this.props.saveLabel ? this.props.saveLabel : 'Save'}
                  </Button>
                </div>
              </ModalFooter>
              {this.props.error && <div className="alert alert-danger">{this.props.error}</div>}
            </form>
          )}
        />
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/dialogs/DayDialog.tsx